import { destination, point as turfPoint } from '@turf/turf';
import { nanoid } from 'nanoid';
import type { PolygonObject } from '~/common/types';

export const SmallProjectAreaLimit = 3; // project area in acres

export const CIRCLE_PROJECT_RADIUS = Math.round(0.25 * 5280); // in feet (1/4 mile);

export const CIRCLE_PROJECT_AREA_LIMIT = Math.round(Math.PI * (CIRCLE_PROJECT_RADIUS * CIRCLE_PROJECT_RADIUS));

const options = { units: 'feet' } as const;

export function createFixedAreaFromPoint(
  { lng, lat }: { lng: number; lat: number },
  area: typeof SmallProjectAreaLimit,
): Omit<PolygonObject, 'createdBy' | 'updatedBy'> {
  const c = turfPoint([lng, lat]);
  const sf = area * 43560;
  const segmentLength = Math.sqrt(sf);
  const d = Math.hypot(segmentLength / 2, segmentLength / 2);

  const bearings = [45, 135, -135, -45, 45];

  const corners = bearings.map((b) => destination(c, d, b, options));

  const polygon: Omit<PolygonObject, 'createdBy' | 'updatedBy'> = {
    id: nanoid(),
    sortOrder: 'a1',
    type: 'polygon',
    title: '',
    description: '',
    geometry: {
      type: 'Polygon',
      coordinates: [corners.map((p) => [...p.geometry.coordinates])],
    },
    properties: {
      color: 'orange',
      fillOpacity: 0.25,
      strokeOpacity: 1,
      strokeWidth: 4,
      strokeStyle: 'dashed',
      showArea: true,
      showTitle: false,
      labelAlwaysVisible: false,
    },
  };

  return polygon;
}
